'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function MarketStatus() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    setIsHydrated(true);
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Market hours: 9:15 AM to 3:30 PM IST (simplified check)
  const getMarketStatus = () => {
    if (!isHydrated) return { isOpen: false, message: 'Loading...' };
    
    const hours = currentTime?.getHours();
    const minutes = currentTime?.getMinutes();
    const currentMinutes = hours * 60 + minutes;
    const marketOpen = 9 * 60 + 15; // 9:15 AM
    const marketClose = 15 * 60 + 30; // 3:30 PM

    if (currentMinutes >= marketOpen && currentMinutes <= marketClose) {
      return { isOpen: true, message: 'Markets Open' };
    }
    return { isOpen: false, message: 'Markets Closed' };
  };

  const status = getMarketStatus();

  return (
    <div className="flex items-center gap-6 flex-wrap">
      <div className="flex items-center gap-3">
        <div
          className={`w-3 h-3 rounded-full ${
            status?.isOpen ? 'bg-primary pulse-glow' : 'bg-secondary'
          }`}
        />
        <span className="text-lg font-semibold text-foreground">
          {status?.message}
        </span>
      </div>
      {isHydrated && (
        <div className="flex items-center gap-2 text-muted-foreground">
          <Icon name="ClockIcon" size={18} />
          <span className="font-mono text-sm">
            Last Updated: {currentTime?.toLocaleTimeString('en-IN')}
          </span>
        </div>
      )}
    </div>
  );
}